interface SelectGroupIconProps {
  className?: string;
  width?: string;
  size?: string;
  height?: string;
  style?: React.CSSProperties;
  color?: string;
  title?: string;
  noPointer?: boolean;
}

const SelectGroupIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}: SelectGroupIconProps) => {
  const strokeColor = color || "var(--color-easil-gray-x-dark)";
  return (
    <svg
      className={className}
      style={style}
      data-no-pointer={noPointer}
      width={width || size || 20}
      height={height || size || 20}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="title"
    >
      <title>{title}</title>
      <g
        transform="translate(10, 10) rotate(-90) translate(-10, -10)"
        fill="none"
        fillRule="evenodd"
      >
        <rect x="0" y="0" width="20" height="20" />
        <rect
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="6"
          y="6"
          width="5"
          height="5"
          rx="2.5"
        />
        <path
          d="M14,9 L14,12 C14,13.1045695 13.1045695,14 12,14 L9,14 L9,14"
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <rect
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="1.5"
          y="1.5"
          width="3"
          height="3"
          rx="1.5"
        />
        <rect
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="15.5"
          y="1.5"
          width="3"
          height="3"
          rx="1.5"
        />
        <rect
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="1.5"
          y="15.5"
          width="3"
          height="3"
          rx="1.5"
        />
        <rect
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          x="15.5"
          y="15.5"
          width="3"
          height="3"
          rx="1.5"
        />
        <line
          x1="17"
          y1="15"
          x2="17"
          y2="5"
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="15"
          y1="17"
          x2="5"
          y2="17"
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="3"
          y1="15"
          x2="3"
          y2="5"
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <line
          x1="5"
          y1="3"
          x2="15"
          y2="3"
          stroke={strokeColor}
          strokeWidth="1.75"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};

export default SelectGroupIcon;
